// extracted by mini-css-extract-plugin
export default {"postImage":"ReportPostCard_postImage__hHQ7G"};